import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Produto, Message } from 'src/app/_models';
import { FilterData } from 'src/app/_models/FilterData';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProdutoService } from 'src/app/_services/produto.service';
import { SelectionModel } from '@angular/cdk/collections';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';

export interface Filtros {
  CnaeNcm: string;
  CodigoMaterial: string;
  DescProduto: string;
  TipoPesquisa: string;
}

@Component({
  selector: 'app-produto-modal',
  templateUrl: './produto-modal.component.html',
  styleUrls: ['./produto-modal.component.css']
})

export class ProdutoModalComponent implements OnInit {
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  selection = new SelectionModel<Produto>(true, []);
  prodForm: FormGroup;
  showProgressBar = false;
  filtros = {} as Filtros;
  messageModel = {} as Message;
  displayedColumns: string[] = ['select', 'cnae', 'codigoMaterial', 'descricao', 'contacontabil', 'contrato', 'ipi'];
  dataSourceProdutosModal = new MatTableDataSource<Produto>(new Array<Produto>());
  produtos = [] as Produto[];
  get f() { return this.prodForm.controls; }

  constructor(private formBuilder: FormBuilder,
    private produtoService: ProdutoService,
    private dialog: MatDialog,
    private matDialogRef: MatDialogRef<ProdutoModalComponent, Produto[]>,
    @Inject(MAT_DIALOG_DATA) public filterInjectedData: FilterData) {

  }

  ngOnInit() {
    this.prodForm = this.formBuilder.group({
      frmCnaeNcm: [''],
      frmCodigoMaterial: [''],
      frmDescProduto: ['', Validators.minLength(3)],
      frmTipoBusca: ['']
    });
    this.filtros.TipoPesquisa = 'R';
  }

  incluir(): void {
    this.matDialogRef.close(this.selection.selected);
  }

  cancelar(): void {
    this.matDialogRef.close();
  }

  applyFilter(event) {
    this.dataSourceProdutosModal.filter = event;
  }

  pesquisar() {
    this.selection.clear();
    this.filtros.CnaeNcm = this.filtros.CnaeNcm || '';
    this.filtros.CodigoMaterial = this.filtros.CodigoMaterial || '';
    this.filtros.DescProduto = this.filtros.DescProduto || '';
    this.filtros.TipoPesquisa = this.filtros.TipoPesquisa || 'R';

    this.filterInjectedData.Fornecedor = this.filterInjectedData.Fornecedor || '';
    this.filterInjectedData.TipoDocumento = this.filterInjectedData.TipoDocumento || null;

    if (this.filtros.CnaeNcm === '' && this.filtros.CodigoMaterial === '' && this.filtros.DescProduto === '') {
      return;
    }

    if (this.filtros.DescProduto !== '' && this.f.frmDescProduto.invalid) {
      return;
    }

    this.showProgressBar = true;
    this.produtoService.buscarProdutoMaterialRecorrente(this.filterInjectedData.Fornecedor
      , this.filterInjectedData.TipoDocumento
      , this.filtros.CnaeNcm
      , this.filtros.TipoPesquisa
      , this.filtros.DescProduto
      , this.filtros.CodigoMaterial)
      .subscribe(result => {
        result.data = result.data || [];
        if (result.success && result.data.length > 0) {
          this.produtos = result.data as Produto[];
          if (this.produtos.length > 0) {
            this.produtos.map((element, index) => {
              this.produtos[index].idSapProdutoFormated = this.produtos[index].idSapProdutoFormated || null;
              this.produtos[index].idSapProduto = this.produtos[index].idSapProduto || null;
              this.produtos[index].idSapProdutoFormated = this.produtos[index].idSapProdutoFormated ?? +this.produtos[index].idSapProduto;
            });
            this.dataSourceProdutosModal = new MatTableDataSource<Produto>(this.produtos);
            this.dataSourceProdutosModal.paginator = this.paginator;
          }
        } else {
          result.errors = result.errors || [];
          if (result.errors.length > 0) {
            let mensagem = '';
            result.errors.map(element => mensagem = mensagem + element + ' <br>');
            this.ExibeMensagem('', mensagem, 'warning');
          }
          if (result.data.message) {
            result.data.message = result.data.message || 'Produto / Serviço não encontrado.';
            this.ExibeMensagem('', result.data.message, 'warning');
          }
        }
      }, err => {
        console.log(err);
      })
      .add(() => { 
        this.filterInjectedData.TipoBuscaBloqueado = false;
        this.showProgressBar = false; 
      });
  }

  ExibeMensagem(title: string, message: string, status: string = null) {
    this.messageModel = new Message(title, '', `${message} `, status);
    return this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
  }

  // Controle Select
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceProdutosModal.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSourceProdutosModal.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Produto, index?: number): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${index + 1}`;
  }
}
